import { render, staticRenderFns } from "./EmptySystemCard.vue?vue&type=template&id=01ae8c16&scoped=true&"
import script from "./EmptySystemCard.vue?vue&type=script&lang=js&"
export * from "./EmptySystemCard.vue?vue&type=script&lang=js&"
import style0 from "./EmptySystemCard.vue?vue&type=style&index=0&id=01ae8c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae8c16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VImg,VRow})
